/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useCallback } from 'react';
import { useQuery, useMutation } from 'react-query';
import { useLedgerFilteredWallets } from './ledgerWallets';
import { RATES_QUERY_KEY } from '../sharedQueries';

import { WALLETS_ALL } from '../../screens/Accounts/queries';
import { getTotalBalance } from '../../screens/Accounts/partials/helpers';
import { getCachedHiddenUserCurrencyList } from '../caching';
import { useSetting } from './settings';
import { useUserPersonalInfo } from './user';
import { USER_WAIT_LIST_RANK } from '../../screens/Card/mutations';
import { cardProviders } from '../../screens/Card/constants';

const useEligibleForFreeCard = (isCardReplacement, cardType) => {
  const [eligible, setEligible] = useState({
    isEligible: false,
    isWaitinglist: false,
    isLoading: true,
  });
  const [userWaitingPosition, setUserWaitingPosition] = useState(null);

  const [waitlistFreeCardOrderToggle] = useSetting(
    'app_features',
    'waitlist_free_card_order_toggle'
  );
  const { email } = useUserPersonalInfo();
  const { mutate: getUserPosition, isLoading: isLoadingWaitingList } = useMutation(
    USER_WAIT_LIST_RANK,
    {
      onSettled: (dataRank, error) => {
        if (!error) {
          if (userWaitingPosition === null && dataRank) {
            setUserWaitingPosition(dataRank?.isRanked);
          }
        }
      },
    }
  );
  useEffect(() => {
    if (waitlistFreeCardOrderToggle && email) {
      getUserPosition(email);
    }
  }, [email]);

  const [orderCardFreeLimitBalance] = useSetting('server_configurations', 'promo_amount_free_card');
  const [orderCardFreeLimitBalanceCurrency] = useSetting(
    'server_configurations',
    'promo_amount_free_card_currency'
  );

  const { data: rates } = useQuery(RATES_QUERY_KEY);
  const { data: wallets } = useLedgerFilteredWallets(WALLETS_ALL);

  const cacheHiddenCurrency = useCallback(
    (wallet) => getCachedHiddenUserCurrencyList().indexOf(wallet.coin.toUpperCase()) === -1,
    []
  );

  useEffect(() => {
    const { totalBalanceInFiat } = getTotalBalance(
      orderCardFreeLimitBalanceCurrency,
      (wallets || []).filter(cacheHiddenCurrency),
      rates
    );

    if (isCardReplacement && cardType === cardProviders.MONAVATE) {
      setEligible({
        isEligible: false,
        isWaitinglist: false,
        isLoading: isLoadingWaitingList,
      });
    } else if (parseFloat(totalBalanceInFiat) >= orderCardFreeLimitBalance && !isCardReplacement) {
      setEligible({
        isEligible: true,
        isWaitinglist: false,
        isLoading: isLoadingWaitingList,
      });
    } else if (userWaitingPosition) {
      setEligible({
        isEligible: true,
        isWaitinglist: true,
        isLoading: isLoadingWaitingList,
      });
    } else {
      setEligible({
        isEligible: false,
        isLoading: isLoadingWaitingList,
      });
    }
  }, [rates, wallets, userWaitingPosition, isLoadingWaitingList, orderCardFreeLimitBalance]);

  return eligible;
};

export default useEligibleForFreeCard;
